import React, { Fragment, useState } from "react";
import { Button } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";

import { signOut } from "../../../actions/auth";

import style from "./Confirmation.scss";

const redirectionSite = window.___APP_CONFIG___.REDIRECTION_SITE;

export const Confirmation = () => {
  const dispatch = useDispatch();

  return (
    <Fragment>
      <div className={style.container}>
        <div className={style.grayContent}>
          la creación de tu cuenta está en proceso, te estaremos contactando cuando ya este activa para
          comenzar a invertir.
        </div>
      </div>
      <span className={style.footer}>
        <Button
          className={style.button}
          onClick={() => {
            dispatch(signOut());
            sessionStorage.clear();
            window.location.href = redirectionSite;
          }}
        >
          Salir
        </Button>
      </span>
    </Fragment>
  );
};
